import React, {useContext, useEffect, useState} from 'react';
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from '@apollo/client';
import Button from '../../UI/Button/Button';
import {
    IS_CUSTOMER_SUBSCRIBED,
    UPDATE_CUSTOMER,
} from '../../../screens/PersonalAreaScreen/queriesPersonalArea';
import './PersonalAreaNewsletter.scss';
import {useUserContext} from '../../../context/UserContext';
import {usePopup} from '../../../context/PopupContext';

const PersonalAreaNewsletter = () => {
    const {showAddToCartPopupMessage} = usePopup();
    const { t } = useTranslation();
    const {user} = useUserContext();
    const [isSubscribed, setIsSubscribed] = useState(false)
    const [updateCustomerV2] = useMutation(UPDATE_CUSTOMER);
    const {data, refetch} = useQuery(IS_CUSTOMER_SUBSCRIBED, {
        skip: !user,
    });
    useEffect(() => {
        if (data && data.isSubscribed) {
            setIsSubscribed(data.isSubscribed.is_subscribed)
        }
    }, [data])
    const clickHandler = () => {
        setIsSubscribed(prevState => !prevState)
    }
    const handleMutation = async () => {
        await updateCustomerV2({variables: {input: {is_subscribed: isSubscribed}}})
            .then(() => showAddToCartPopupMessage(t(isSubscribed ? 'newsletterSlider.successSubscribe' : 'newsletterSlider.removedSubscription'), 'success', 4000))
            .catch((err) => showAddToCartPopupMessage(err.message, 'error', 4000))
    }

    return (
        <div className="newsletter">
            <h1 className="newsletter__title"><T id="newsletter.header"/></h1>
            <>
                <br/>
                <div className="newsletter__content">
                    <input type="checkbox" name="yes" id="yes" style={{width: 'inherit'}} onClick={() => {
                        clickHandler()
                    }} checked={isSubscribed}/>
                    <span className="newsletter__info">
                            <T id="newsletter.agree"/>
                        </span>
                </div>
                <Button className="newsletter__button" type="submit" trait="profile-hover"
                        text={<T id="newsletter.submit"/>} onClick={handleMutation}/>
            </>
        </div>

    );
};

export default PersonalAreaNewsletter;
